import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import AppComponent from "./AppComponent";
import LoadingIndicator from "./components/loading/LoadingIndicator";
import store from "./store/store";
import "./styles/css/index.css";
import "./styles/css-variables"
import "./utils/i18next";

class WebComponent extends HTMLElement {
  connectedCallback() {
    ReactDOM.render(
     <Provider store={store}>
      <div>
        <AppComponent />
        <LoadingIndicator />
      </div>
    </Provider>,
      this
    );
  }
}


const ELEMENT_ID = "provider-search";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
